<div class="bg-white rounded-lg h-full w-full border flex flex-col">
  <!-- Header -->
  <div class="p-5 py-3 pb-1  border-b capitalize">
    <p class="text-sm font-semibold">Calender</p>
  

  <div>
    <div class="flex justify-between items-center text-xs px-5 mt-2">
      <button (click)="changeWeek(-1)" class="flex items-center justify-center w-5 h-5 border rounded"><i class="ri-arrow-drop-left-line"></i></button>
      <span>{{ formattedCurrentMonthYear }}</span>
      <button (click)="changeWeek(1)" class="flex items-center justify-center w-5 h-5 border rounded"><i class="ri-arrow-drop-right-line"></i></button>
    </div>

    <div class="flex justify-between mt-2">
      @for (day of weekDays; track $index) {
        <button (click)="selectDay(day.date)" 
          [ngClass]="{ 'bg-zinc-200': selectedDate.getTime() === day.date.getTime() }"
          class="flex flex-col items-center justify-center py-3 px-2 rounded hover:bg-zinc-100">
          <span class="text-xs uppercase">{{ day.shortDay }}</span>
          <p class="font-medium text-lg">{{ day.label }}</p>
        </button>
      }
      
    </div>
  </div>
</div>

  <div class="flex-1 overflow-hidden">
    <div class="overflow-y-auto h-full min-h-0">

      <ul class="p-5 py-3 grid grid-cols-1 gap-2">
        @for (schedule of schedules; track $index) {
          <li>
            <a class="flex h-10 items-center font-medium border rounded-md px-2 hover:bg-zinc-100">
              <p class="w-24 flex items-center justify-center gap-1 border-e h-full text-sm">{{ schedule.time }}<span class="text-xs font-normal">am</span></p>
              <div class="flex justify-between w-full ps-2">
                <p>{{ schedule.teacher }}</p>
                <span class="text-xs px-2 py-1 rounded bg-zinc-100">{{ schedule.grade }}</span>
              </div>
            </a>
          </li>
          
        }@empty {
          <li>No schedules for this day</li>
        }

        
      </ul>

    </div>
  </div>
</div>
